export const LOCAL_STORAGE_JWT_KEY = "__9ucxjsi2-Upn79"
export const LOCAL_STORAGE_JWT_KEY_AREA_RESTRITA = "__cuddcx52#%jsi2-Upn79-ASkFm3k94"

export const Regex = {
    CEP: /^\d{5}\-\d{3}_*$/
}